(function () {
  'use strict';

  var CART_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M10.5 21C11.3284 21 12 20.3284 12 19.5C12 18.6716 11.3284 18 10.5 18C9.67157 18 9 18.6716 9 19.5C9 20.3284 9.67157 21 10.5 21Z" fill="currentColor"></path>' +
      '<path d="M17.5 21C18.3284 21 19 20.3284 19 19.5C19 18.6716 18.3284 18 17.5 18C16.6716 18 16 18.6716 16 19.5C16 20.3284 16.6716 21 17.5 21Z" fill="currentColor"></path>' +
      '<path d="M13 13H15V10.01H17.99V8.01003H15V5.03003H13V8.01003H10.01V10.01H13V13Z" fill="currentColor"></path>' +
      '<path d="M10 17H18C18.2014 16.9994 18.398 16.938 18.564 16.8238C18.7299 16.7096 18.8575 16.5479 18.93 16.36L21.76 9H19.62L17.31 15H10.67L6.18 4.23C6.02776 3.86507 5.77077 3.55344 5.44149 3.33452C5.11221 3.11559 4.72542 2.99918 4.33 3H2V5H4.33L9.08 16.38C9.15502 16.5626 9.28242 16.719 9.44614 16.8293C9.60986 16.9396 9.80257 16.999 10 17Z" fill="currentColor"></path>' +
    '</svg>';

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[character];
    });
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.DT_THEME &&
      window.DT_THEME.moneyFormat
    ) {
      return window.Shopify.formatMoney(
        cents,
        window.DT_THEME.moneyFormat
      );
    }

    return (Number(cents || 0) / 100).toFixed(2);
  }

  function normalizeSearchText(value) {
    var text = String(value || '').toLowerCase();

    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function compactSearchText(value) {
    return normalizeSearchText(value).replace(/\s+/g, '');
  }

  function getProductSkuValues(product, detail) {
    var skuValues = [];

    if (detail && detail.sku) {
      skuValues.push(detail.sku);
    }

    if (product && Array.isArray(product.variants)) {
      product.variants.forEach(function (variant) {
        if (variant && variant.sku) {
          skuValues.push(variant.sku);
        }
      });
    }

    return skuValues.filter(function (sku, index, values) {
      return values.indexOf(sku) === index;
    });
  }

  function getProductRelevance(product, detail, query) {
    var normalizedQuery = normalizeSearchText(query);
    var compactQuery = compactSearchText(query);
    var normalizedTitle = normalizeSearchText(product.title);
    var skuValues = getProductSkuValues(product, detail);
    var normalizedSkus = skuValues.map(normalizeSearchText);
    var compactSkus = skuValues.map(compactSearchText);
    var normalizedSku = normalizedSkus.join(' ');
    var queryTokens = normalizedQuery
      .split(' ')
      .filter(function (token) {
        return token.length > 0;
      });

    if (!normalizedQuery) {
      return 0;
    }

    // Exact and partial SKU matches are the strongest buying-intent signal.
    if (
      compactQuery.length >= 3 &&
      compactSkus.some(function (sku) {
        return sku === compactQuery;
      })
    ) {
      return 1200;
    }

    if (
      compactQuery.length >= 3 &&
      compactSkus.some(function (sku) {
        return sku.indexOf(compactQuery) !== -1;
      })
    ) {
      return 1100;
    }

    if (normalizedTitle === normalizedQuery) {
      return 1000;
    }

    if (normalizedTitle.indexOf(normalizedQuery + ' ') === 0) {
      return 900;
    }

    if (normalizedTitle.indexOf(normalizedQuery) !== -1) {
      return 800;
    }

    if (
      queryTokens.length > 0 &&
      queryTokens.every(function (token) {
        return normalizedTitle.indexOf(token) !== -1;
      })
    ) {
      return 700;
    }

    // Allow a model/SKU token to complement title words, but require every
    // meaningful query token to be present in either the title or the SKU.
    if (
      queryTokens.length > 1 &&
      queryTokens.every(function (token) {
        return (
          normalizedTitle.indexOf(token) !== -1 ||
          normalizedSku.indexOf(token) !== -1
        );
      })
    ) {
      return 600;
    }

    return 0;
  }

  function buildProductQuery(query) {
    // Shopify's field-qualified wildcard query returned zero results in this store.
    // Retrieve normal search candidates, then require literal title/SKU matches.
    return String(query || '').trim();
  }

  function productSearchUrl(query, page, section) {
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var params = new URLSearchParams({
      q: buildProductQuery(query), type: 'product',
      'options[prefix]': 'last', 'options[unavailable_products]': 'last',
      page: String(page || 1)
    });
    if (section) params.set('section_id', 'wps-product-search');
    return rootPath + 'search?' + params.toString();
  }

  async function getProductDetails(product) {
    if (product.searchDetail) return product.searchDetail;
    try {
      var productUrl = product.url.split('?')[0];
      var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
      var inventoryUrl =
        productUrl + separator + 'section_id=predictive-inventory';

      var response = await fetch(inventoryUrl, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Inventory request failed');
      }

      var responseText = await response.text();
      var parsedDocument = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );
      var sectionElement = parsedDocument.querySelector(
        '#shopify-section-predictive-inventory'
      );
      var jsonText = sectionElement
        ? sectionElement.textContent.trim()
        : responseText.trim();
      var details = JSON.parse(jsonText);

      return {
        variantId: details.variantId || null,
        sku: details.sku || '',
        available: Boolean(details.available),
        inventoryQuantity:
          typeof details.inventoryQuantity === 'number'
            ? details.inventoryQuantity
            : null,
        stockVisible: Boolean(details.stockVisible)
      };
    } catch (error) {
      console.error('Error fetching product inventory:', error);

      return {
        variantId: null,
        sku: '',
        available: false,
        inventoryQuantity: null,
        stockVisible: false
      };
    }
  }

  function updateCartUI() {
    fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.CartCount').forEach(function (element) {
          element.textContent = cart.item_count || 0;

          element.classList.toggle(
            'hidden-count',
            !cart.item_count
          );
        });

        var wrapper = document.getElementById('CartCount');

        if (wrapper) {
          wrapper.classList.toggle(
            'hidden',
            !cart.item_count
          );
        }
      })
      .catch(function (error) {
        console.error('Cart count update error:', error);
      });

    if (
      window.ajaxCart &&
      typeof window.ajaxCart.load === 'function'
    ) {
      window.ajaxCart.load();
    } else if (
      window.ajaxCart &&
      typeof window.ajaxCart.loadCart === 'function'
    ) {
      window.ajaxCart.loadCart();
    }

    window.setTimeout(function () {
      var opener = document.querySelector(
        '.js-drawer-open-right, .dT_MiniCartModelBtn'
      );

      if (opener) {
        opener.click();
      }
    }, 250);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity) || 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(
              data.description || 'Unable to add item'
            );
          });
        }

        return response.json();
      })
      .then(function (data) {
        updateCartUI();
        return data;
      });
  }

  function initializeSearch(root) {
    var input = root.querySelector(
      '.wps-predictive-search-input'
    );

    var results = root.querySelector(
      '.wps-predictive-search-results'
    );

    if (
      !input ||
      !results ||
      root.dataset.predictiveInitialized === 'true'
    ) {
      return;
    }

    root.dataset.predictiveInitialized = 'true';

    var timer;
    var requestNumber = 0;
    var nextPage = null;
    var loadedProducts = [];
    var activeQuery = '';
    var loadingMore = false;
    var form = input.closest('form');
    if (form) form.addEventListener('submit', function (event) {
      if (!buildProductQuery(input.value)) return;
      event.preventDefault();
      window.location.assign(productSearchUrl(input.value.trim(), 1, false));
    });

    function closePredictiveSearch() {
      window.clearTimeout(timer);

      /*
       * Invalidates any pending request so an old response
       * cannot reopen the dropdown after it has been closed.
       */
      requestNumber++;

      loadingMore = false;
      var moreButton = results.querySelector('[data-wps-search-more]');
      if (moreButton) { moreButton.disabled = false; moreButton.textContent = 'Load more matches'; }
      results.hidden = true;
      results.setAttribute('aria-hidden', 'true');
      results.classList.remove(
        'active',
        'is-active',
        'open',
        'show',
        'visible'
      );
    }

    function openPredictiveSearch() {
      results.hidden = false;
      results.setAttribute('aria-hidden', 'false');
    }

    /*
     * Expose the close function on this search instance so the
     * global outside-click handler can close it.
     */
    root.wpsClosePredictiveSearch =
      closePredictiveSearch;

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      requestNumber++;
      nextPage = null;
      loadedProducts = [];
      results.innerHTML = '';
      results.hidden = true;

      var query = input.value.trim();

      if (query.length < 2) {
        requestNumber++;
        results.innerHTML = '';
        closePredictiveSearch();
        return;
      }

      timer = window.setTimeout(function () {
        search(query);
      }, 300);
    });

    /*
     * Reopen existing results when the input is focused again.
     */
    input.addEventListener('focus', function () {
      var query = input.value.trim();

      if (
        query.length >= 2 &&
        results.innerHTML.trim() !== ''
      ) {
        openPredictiveSearch();
      }
    });

    async function search(query, page) {
      page = page || 1;
      var currentRequest = ++requestNumber;
      loadingMore = true;
      if (page === 1) {
        loadedProducts = [];
        activeQuery = query;
        results.innerHTML = '<div role="status">Searching…</div>';
        openPredictiveSearch();
      }
      try {
        var found = false;
        // Skip pages containing only fuzzy matches. Do not report "no results"
        // while there are still candidate pages that have not been checked.
        do {
          var response = await fetch(productSearchUrl(query, page, true), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search request failed');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var template = doc.querySelector('[data-wps-search-json]');
          if (!template) throw new Error('Search response missing');
          var data = JSON.parse(template.content.textContent);
          if (currentRequest !== requestNumber || input.value.trim() !== query) return;
          if (!Array.isArray(data.products)) throw new Error('Invalid search response');
          nextPage = Number.isInteger(data.nextPage) && data.nextPage > page ? data.nextPage : null;
          var seen = new Set(loadedProducts.map(function (product) { return product.id; }));
          data.products.forEach(function (product) {
            if (!seen.has(product.id) && getProductRelevance(product, product.searchDetail || {}, query) > 0) {
              loadedProducts.push(product);
              seen.add(product.id);
              found = true;
            }
          });
          page = nextPage;
        } while (!found && nextPage);
        await render(loadedProducts, query, currentRequest);
      } catch (error) {
        if (currentRequest !== requestNumber || input.value.trim() !== query) return;
        results.innerHTML = '<div role="status">Search could not load. <a href="' +
          escapeHtml(productSearchUrl(query, 1, false)) + '">View search results</a></div>';
        openPredictiveSearch();
      } finally {
        if (currentRequest === requestNumber) loadingMore = false;
      }
    }

    function searchLinks(query) {
    return '<div class="dt-search-actions">' +
        (nextPage
            ? '<button type="button" class="dt-sc-btn" data-wps-search-more>Load more matches</button>'
            : ''
        ) +
        '<a class="dt-sc-btn" href="' + escapeHtml(productSearchUrl(query, 1, false)) + '">View all matches</a>' +
    '</div>';
}

    results.addEventListener('click', function (event) {
      var more = event.target.closest('[data-wps-search-more]');
      if (!more) return;
      event.preventDefault();
      if (loadingMore || !nextPage) return;
      more.disabled = true;
      more.textContent = 'Loading…';
      search(activeQuery, nextPage);
    });

    async function render(
      products,
      query,
      currentRequest
    ) {
      if (currentRequest !== requestNumber) {
        return;
      }

      if (!products.length) {
        results.innerHTML =
          '<div class="no-results">No results found</div>';

        openPredictiveSearch();
        return;
      }

      var detailList = await Promise.all(
        products.map(getProductDetails)
      );

      if (currentRequest !== requestNumber) {
        return;
      }

      var detailsById = {};

      products.forEach(function (product, index) {
        detailsById[product.id] =
          detailList[index];
      });

      products = products
        .map(function (product, index) {
          var detail = detailsById[product.id] || {};

          return {
            product: product,
            originalIndex: index,
            relevance: getProductRelevance(
              product,
              detail,
              query
            ),
            available: Boolean(detail.available)
          };
        })
        .filter(function (entry) {
          return entry.relevance > 0;
        })
        .sort(function (a, b) {
          if (a.relevance !== b.relevance) {
            return b.relevance - a.relevance;
          }

          if (a.available !== b.available) {
            return a.available ? -1 : 1;
          }

          return a.originalIndex - b.originalIndex;
        })
        .map(function (entry) {
          return entry.product;
        });

      if (!products.length) {
        results.innerHTML =
          '<div class="no-results">No matching products found.</div>' + searchLinks(query);

        openPredictiveSearch();
        return;
      }

      var html =
        '<ul class="predictive-results-list">';

      products.forEach(function (product) {
        var detail =
          detailsById[product.id] || {};

        var image =
          product.image || '';

        var productTitle =
          product.title || '';

        var productUrl =
          product.url || '#';

        html +=
          '<li class="predictive-product-item">' +

            '<div class="predictive-product-info">' +

              (
                image
                  ? '<a href="' +
                    escapeHtml(productUrl) +
                    '" class="predictive-product-image-link">' +
                      '<img src="' +
                      escapeHtml(image) +
                      '" alt="' +
                      escapeHtml(productTitle) +
                      '" loading="lazy">' +
                    '</a>'
                  : ''
              ) +

              '<div class="predictive-product-copy">' +

                '<a href="' +
                escapeHtml(productUrl) +
                '" class="product-link">' +
                escapeHtml(productTitle) +
                '</a>' +

                (
                  detail.sku
                    ? '<span class="predictive-product-sku">' +
                      'SKU: ' +
                      escapeHtml(detail.sku) +
                      '</span>'
                    : ''
                ) +

                (
                  detail.stockVisible
                    ? (
                        detail.available
                          ? '<span class="predictive-product-stock in-stock">' +
                            (
                              typeof detail.inventoryQuantity === 'number'
                                ? 'Stock: ' + detail.inventoryQuantity
                                : 'In Stock'
                            ) +
                            '</span>'
                          : '<span class="predictive-product-stock out-of-stock">' +
                            'Out of Stock' +
                            '</span>'
                      )
                    : ''
                ) +

                (
                  root.dataset.showPrice === 'true'
                    ? '<strong class="predictive-product-price">' +
                      formatMoney(product.price) +
                      '</strong>'
                    : ''
                ) +

              '</div>' +

            '</div>' +

            '<div class="predictive-actions">' +

              '<div class="quantity-selector">' +

                '<button type="button" ' +
                'class="qty-btn" ' +
                'data-action="minus" ' +
                'aria-label="Decrease quantity">' +
                '−' +
                '</button>' +

                '<input type="number" ' +
                'value="1" ' +
                'class="qty-input" ' +
                'min="1" ' +
                'step="1" ' +
                'inputmode="numeric" ' +
                'aria-label="Quantity">' +

                '<button type="button" ' +
                'class="qty-btn" ' +
                'data-action="plus" ' +
                'aria-label="Increase quantity">' +
                '+' +
                '</button>' +

              '</div>' +

              '<button type="button" ' +
              'class="add-to-cart-btn" ' +
              'data-variant-id="' +
              escapeHtml(detail.variantId || '') +
              '" ' +

              (
                !detail.available
                  ? 'disabled aria-disabled="true"'
                  : ''
              ) +

              ' aria-label="Add ' +
              escapeHtml(productTitle) +
              ' to cart">' +

              CART_ICON +

              '</button>' +

            '</div>' +

          '</li>';
      });

      html += '</ul>' + searchLinks(query);

      results.innerHTML = html;

      openPredictiveSearch();
    }

    results.addEventListener(
      'click',
      function (event) {
        var quantityButton =
          event.target.closest('.qty-btn');

        if (quantityButton) {
          event.preventDefault();
          event.stopPropagation();

          var quantityInput =
            quantityButton.parentElement.querySelector(
              '.qty-input'
            );

          if (!quantityInput) {
            return;
          }

          var current = Math.max(
            1,
            parseInt(
              quantityInput.value,
              10
            ) || 1
          );

          if (
            quantityButton.dataset.action ===
            'plus'
          ) {
            quantityInput.value =
              current + 1;
          } else {
            quantityInput.value =
              Math.max(1, current - 1);
          }

          return;
        }

        var addButton =
          event.target.closest(
            '.add-to-cart-btn'
          );

        if (
          !addButton ||
          addButton.disabled
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var item =
          addButton.closest(
            '.predictive-product-item'
          );

        if (!item) {
          return;
        }

        var quantityInput =
          item.querySelector('.qty-input');

        var quantity = Math.max(
          1,
          parseInt(
            quantityInput
              ? quantityInput.value
              : 1,
            10
          ) || 1
        );

        var variantId =
          addButton.dataset.variantId;

        if (!variantId) {
          return;
        }

        addButton.disabled = true;
        addButton.classList.add('loading');

        addToCart(
          variantId,
          quantity
        )
          .then(function () {
            addButton.classList.add(
              'added'
            );

            window.setTimeout(
              function () {
                addButton.classList.remove(
                  'added'
                );
              },
              1500
            );
          })
          .catch(function (error) {
            console.error(
              'Cart Error:',
              error
            );

            window.alert(
              error.message ||
              'Unable to add this item to the cart.'
            );
          })
          .finally(function () {
            addButton.disabled = false;
            addButton.classList.remove(
              'loading'
            );
          });
      }
    );

    results.addEventListener(
      'change',
      function (event) {
        if (
          !event.target.matches(
            '.qty-input'
          )
        ) {
          return;
        }

        var quantity = parseInt(
          event.target.value,
          10
        );

        event.target.value =
          Number.isNaN(quantity) ||
          quantity < 1
            ? 1
            : quantity;
      }
    );
  }

  function initAll() {
    document
      .querySelectorAll(
        '.wps-old-predictive-search'
      )
      .forEach(initializeSearch);
  }

  function initializeOutsideClick() {
    if (
      document.documentElement.dataset
        .wpsSearchOutsideClick === 'true'
    ) {
      return;
    }

    document.documentElement.dataset
      .wpsSearchOutsideClick = 'true';

    /*
     * Capture mode ensures the outside click is detected even if
     * another WPS script stops event propagation.
     */
    document.addEventListener(
      'pointerdown',
      function (event) {
        document
          .querySelectorAll(
            '.wps-old-predictive-search'
          )
          .forEach(function (root) {
            /*
             * Do not close when clicking anywhere inside the
             * current search component, including results,
             * quantity buttons and Add to Cart.
             */
            if (
              root.contains(event.target)
            ) {
              return;
            }

            if (
              typeof root
                .wpsClosePredictiveSearch ===
              'function'
            ) {
              root
                .wpsClosePredictiveSearch();
            } else {
              var results =
                root.querySelector(
                  '.wps-predictive-search-results'
                );

              if (results) {
                results.hidden = true;
                results.setAttribute(
                  'aria-hidden',
                  'true'
                );
              }
            }
          });
      },
      true
    );

    /*
     * Also close the predictive search when Escape is pressed.
     */
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        document
          .querySelectorAll(
            '.wps-old-predictive-search'
          )
          .forEach(function (root) {
            if (
              typeof root
                .wpsClosePredictiveSearch ===
              'function'
            ) {
              root
                .wpsClosePredictiveSearch();
            }
          });

        var activeElement =
          document.activeElement;

        if (
          activeElement &&
          activeElement.matches(
            '.wps-predictive-search-input'
          )
        ) {
          activeElement.blur();
        }
      }
    );
  }

  function initializePredictiveSearch() {
    initAll();
    initializeOutsideClick();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializePredictiveSearch
    );
  } else {
    initializePredictiveSearch();
  }
})();
